/**
 * Formats a given date string into a specific format.
 *
 * @param {string} dateString - The date string to be formatted (format: 'YYYY-MM-DD').
 * @return {string} The formatted date string (format: 'DD/MM/YYYY').
 */

export function formatDate(dateString?: string) {
  if (!dateString) return '-/-/-';

  const [year, month, day] = dateString.split('-');

  const date = new Date(Number(year), Number(month) - 1, Number(day));

  const formattedDay = `0${date.getDate()}`.slice(-2);
  const formattedMonth = `0${date.getMonth() + 1}`.slice(-2);
  const formattedYear = date.getFullYear();

  return `${formattedDay}/${formattedMonth}/${formattedYear}`;
}
